import { render, staticRenderFns } from "./searchResults.vue?vue&type=template&id=ae0994de"
import script from "./searchResults.vue?vue&type=script&lang=ts"
export * from "./searchResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports